/**
 * Services Index
 * 
 * Unified exports for all service utilities and managers
 */

// Core services
export { sessionManager, SessionManager } from './sessionManager';
export { BaseService, createService } from './baseService';
export { impersonationService, ImpersonationService } from './impersonationService';

// Service types
export type { 
  SessionState, 
  AuthRequestConfig, 
  SessionConfig 
} from './sessionManager';

export type { 
  ServiceConfig, 
  ServiceResponse, 
  CacheEntry,
  CrudOperations,
  SearchOperations,
  StatsOperations
} from './baseService';

export type {
  ImpersonationState,
  ImpersonationConfig,
  ImpersonationResult,
  ImpersonationAuditEvent
} from './impersonationService';

// Manager services (moved from simplified)
export { AnalyticsCalculator } from './analyticsCalculator';
export { RateLimitManager, rateLimitManager } from './rateLimitManager';
export { RoleManager, roleManager } from './roleManager';
export { userManager } from './userManager';

export { BookingManager, bookingManager } from './bookingManager';
export { clubManager } from './clubManager';
export { spaceManager } from './spaceManager';
export { StaffManager, staffManager } from './staffManager';
export { OrganizationManager, organizationManager } from './organizationManager';
export { paymentManager } from './paymentManager';
export { auditManager } from './auditManager';
export { permissionManager } from './permissionManager';
export { getTenantManager, tenantManager } from './tenantManager';

// Analytics managers
export { adminAnalyticsManager } from './adminAnalyticsManager';
export { superAdminAnalyticsManager } from './superAdminAnalyticsManager';
export { adminSettingsManager } from './adminSettingsManager';

// Types for the manager services
export type { KPIMetrics, ChartData } from './analyticsCalculator';
export type { RateLimitConfig, RateLimitResult } from './rateLimitManager'; 
